//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    email, alpha, alphaNum, integer, decimal
} from "vuelidate/lib/validators";

export default {
    name: "ViewVuelidateExample",
    data() {
        return {
            text1: null,
            text2: null,
            text3: null,
            text4: null,
            text5: null
        };
    },
    computed: {
        text1eval() {
            const validateText1 = () => (email(this.text1) ? "text-green" : "text-red-9");
            return this.text1 ? validateText1() : "text-orange";
        },
        text2eval() {
            const validateText2 = () => (alpha(this.text2) ? "text-green" : "text-red-9");
            return this.text2 ? validateText2() : "text-orange";
        },
        text3eval() {
            const validateText3 = () => (alphaNum(this.text3) ? "text-green" : "text-red-9");
            return this.text3 ? validateText3() : "text-orange";
        },
        text4eval() {
            const validateText4 = () => (integer(this.text4) ? "text-green" : "text-red-9");
            return this.text4 ? validateText4() : "text-orange";
        },
        text5eval() {
            const validateText5 = () => (decimal(this.text5) ? "text-green" : "text-red-9");
            return this.text5 ? validateText5() : "text-orange";
        }
    }
};
